export default __webpack_public_path__ + "locales/bg/Errors.json?hash=a9389923319c04e273ffe02e4a2eadaf";